import {
  //
  ADD_LOCATION,
  ADD_LOCATION_FAILURE,
  ADD_LOCATION_SUCCESS,
  //
  DELETE_LOCATION,
  DELETE_LOCATION_FAILURE,
  DELETE_LOCATION_SUCCESS,
  //
  EDIT_LOCATION,
  EDIT_LOCATION_FAILURE,
  EDIT_LOCATION_SUCCESS,
  //
  FETCH_LOCATIONS,
  FETCH_LOCATIONS_FAILURE,
  FETCH_LOCATIONS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_LOCATION,
  SEARCH_LOCATION_FAILURE,
  SEARCH_LOCATION_SUCCESS,
  //
  OPEN_WEBSITE_MODAL,
  CLOSE_WEBSITE_MODAL,
  //
  OPEN_ROOM_ADD_MODAL,
  CLOSE_ROOM_ADD_MODAL,
  //
  ADD_ROOM,
  ADD_ROOM_FAILURE,
  ADD_ROOM_SUCCESS,
  //
  FETCH_ROOMS,
  FETCH_ROOMS_FAILURE,
  FETCH_ROOMS_SUCCESS,
  //
  FETCH_ALL_LOCATION,
  FETCH_ALL_LOCATION_SUCCESS,
  FETCH_ALL_LOCATION_FAILURE,
  //
  OPEN_VIEW_ROOMS_MODAL,
  CLOSE_VIEW_ROOMS_MODAL,
  //
  FETCH_ALL_ROOMS,
  FETCH_ALL_ROOMS_SUCCESS,
  FETCH_ALL_ROOMS_FAILURE,
  //
  SEARCH_ROOMS,
  SEARCH_ROOMS_SUCCESS,
  SEARCH_ROOMS_FAILURE,
  //
  DELETE_CARE_ROOM,
  DELETE_CARE_ROOM_SUCCESS,
  DELETE_CARE_ROOM_FAILURE,
  //
  GET_CARE_ROOM_DATA,
  GET_CARE_ROOM_DATA_SUCCESS,
  GET_CARE_ROOM_DATA_FAILURE,
  //
  FETCH_CARE_ROOM_HISTORY,
  FETCH_CARE_ROOM_HISTORY_SUCCESS,
  FETCH_CARE_ROOM_HISTORY_FAILURE,
  //
  SET_ROOM_HISTORY_MODAL,
  //
  EDIT_CARE_ROOM,
  EDIT_CARE_ROOM_SUCCESS,
  EDIT_CARE_ROOM_FAILURE,
  //
  SET_ROOM_ADD_EDIT_MODAL,
  //
  OPEN_INVITE_MODAL,
  CLOSE_INVITE_MODAL,
  //
  INVITE_STAFF,
  INVITE_STAFF_SUCCESS,
  INVITE_STAFF_FAILURE,
  //
  PROFILE_STEP_EDIT,
  PROFILE_STEP_EDIT_SUCCESS,
  PROFILE_STEP_EDIT_FAILURE,
  //
  TOGGLE_INVITE_REV,
  //
  INVITE_REVIEW,
  INVITE_REVIEW_SUCCESS,
  INVITE_REVIEW_FAILURE,
  //
  GENERATE_CARD,
  GENERATE_CARD_SUCCESS,
  GENERATE_CARD_FAILURE,
  SET_CARD_LIST,
  //
  SET_ACTIVE_LOCATION,
  SET_ACTIVE_SURVEY,
  SET_USER_LOCATIONS,
  SET_ACTIVE_PATH,
  SET_USER_PATH,
  //
  FETCH_INVITEES,
  FETCH_INVITEES_SUCCESS,
  FETCH_INVITEES_FAILURE,
  //
  EXPORT_REVIEWS,
  EXPORT_REVIEWS_SUCCESS,
  EXPORT_REVIEWS_FAILURE,
  //
  TOGGLE_TEAM_MODAL,
  //
  DELETE_TEAM,
  DELETE_TEAM_SUCCESS,
  DELETE_TEAM_FAILURE,
  //
  TOGGLE_SORT_MODAL,
  //
  UPDATE_SEQ,
  UPDATE_SEQ_SUCCESS,
  UPDATE_SEQ_FAILURE,
  //
  GET_FEES,
  GET_FEES_SUCCESS,
  GET_FEES_FAILURE,
  //
  UPDATE_FEE,
  UPDATE_FEE_SUCCESS,
  UPDATE_FEE_FAILURE,
  //
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  //
  DELETE_FILE,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAILURE,
  //
  DELETE_VIDEO,
  DELETE_VIDEO_SUCCESS,
  DELETE_VIDEO_FAILURE,
  //
  GET_BACK_VIEW,
  GET_BACK_VIEW_SUCCESS,
  GET_BACK_VIEW_FAILURE,
  //
  EDIT_BASIC,
  EDIT_BASIC_SUCCESS,
  EDIT_BASIC_FAILURE,
} from "./constants";

// List
export const fetchLocations = (payload) => ({
  type: FETCH_LOCATIONS,
  payload,
});
export const fetchSlickCareProfilesSuccess = (payload) => ({
  type: FETCH_LOCATIONS_SUCCESS,
  payload,
});
export const fetchSlickCareProfilesFailure = (payload) => ({
  type: FETCH_LOCATIONS_FAILURE,
  payload,
});
// Search List
export const searchSlickCareProfiles = (payload) => ({
  type: SEARCH_LOCATION,
  payload,
});
export const searchSlickCareProfilesSuccess = (payload) => ({
  type: SEARCH_LOCATION_SUCCESS,
  payload,
});
export const searchSlickCareProfilesFailure = (payload) => ({
  type: SEARCH_LOCATION_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onGetSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onGetSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addSlickCareProfiles = (payload) => ({
  type: ADD_LOCATION,
  payload,
});
export const addSlickCareProfilesSuccess = (payload) => ({
  type: ADD_LOCATION_SUCCESS,
  payload,
});
export const addSlickCareProfilesFailure = (payload) => ({
  type: ADD_LOCATION_FAILURE,
  payload,
});
// EDIT
export const editSlickCareProfiles = (payload) => ({
  type: EDIT_LOCATION,
  payload,
});
export const editSlickCareProfilesSuccess = (payload) => ({
  type: EDIT_LOCATION_SUCCESS,
  payload,
});
export const editSlickCareProfilesFailure = (payload) => ({
  type: EDIT_LOCATION_FAILURE,
  payload,
});
// DELETE
export const deleteSlickCareProfiles = (payload) => ({
  type: DELETE_LOCATION,
  payload,
});
export const deleteSlickCareProfilesSuccess = (payload) => ({
  type: DELETE_LOCATION_SUCCESS,
  payload,
});
export const deleteSlickCareProfilesFailure = (payload) => ({
  type: DELETE_LOCATION_FAILURE,
  payload,
});

export const openWebsiteModal = (payload) => ({
  type: OPEN_WEBSITE_MODAL,
  payload,
});

export const closeWebsiteModal = (payload) => ({
  type: CLOSE_WEBSITE_MODAL,
  payload,
});
//
export const openRoomAddModal = (payload) => ({
  type: OPEN_ROOM_ADD_MODAL,
  payload,
});
export const closeRoomAddModal = (payload) => ({
  type: CLOSE_ROOM_ADD_MODAL,
  payload,
});
// ADD
export const addRoom = (payload) => ({
  type: ADD_ROOM,
  payload,
});
export const addRoomSuccess = (payload) => ({
  type: ADD_ROOM_SUCCESS,
  payload,
});
export const addRoomFailure = (payload) => ({
  type: ADD_ROOM_FAILURE,
  payload,
});
// List
export const fetchRooms = (payload) => ({
  type: FETCH_ROOMS,
  payload,
});
export const fetchRoomsSuccess = (payload) => ({
  type: FETCH_ROOMS_SUCCESS,
  payload,
});
export const fetchRoomsFailure = (payload) => ({
  type: FETCH_ROOMS_FAILURE,
  payload,
});

export const fetchAllLocation = (payload) => ({
  type: FETCH_ALL_LOCATION,
  payload,
});
export const fetchAllLocationSuccess = (payload) => ({
  type: FETCH_ALL_LOCATION_SUCCESS,
  payload,
});
export const fetchAllLocationFailure = (payload) => ({
  type: FETCH_ALL_LOCATION_FAILURE,
  payload,
});
//
export const openViewRoomsModal = (payload) => ({
  type: OPEN_VIEW_ROOMS_MODAL,
  payload,
});
export const clostViewRoomsModal = (payload) => ({
  type: CLOSE_VIEW_ROOMS_MODAL,
  payload,
});
//
export const fetchAllRooms = (payload) => ({
  type: FETCH_ALL_ROOMS,
  payload,
});
export const fetchAllRoomsSuccess = (payload) => ({
  type: FETCH_ALL_ROOMS_SUCCESS,
  payload,
});
export const fetchAllRoomsFailure = (payload) => ({
  type: FETCH_ALL_ROOMS_FAILURE,
  payload,
});

export const searchRooms = (payload, onSuccess, values) => ({
  type: SEARCH_ROOMS,
  payload,
  onSuccess,
  values,
});
export const searchRoomsSuccess = (payload) => ({
  type: SEARCH_ROOMS_SUCCESS,
  payload,
});
export const searchRoomsFailure = (payload) => ({
  type: SEARCH_ROOMS_FAILURE,
  payload,
});

export const deleteCareRoom = (payload) => ({
  type: DELETE_CARE_ROOM,
  payload,
});
export const deleteCareRoomSuccess = (payload) => ({
  type: DELETE_CARE_ROOM_SUCCESS,
  payload,
});
export const deleteCareRoomFailure = (payload) => ({
  type: DELETE_CARE_ROOM_FAILURE,
  payload,
});

export const getCareRoomData = (payload) => ({
  type: GET_CARE_ROOM_DATA,
  payload,
});
export const getCareRoomDataSuccess = (payload) => ({
  type: GET_CARE_ROOM_DATA_SUCCESS,
  payload,
});
export const getCareRoomDataFailure = (payload) => ({
  type: GET_CARE_ROOM_DATA_FAILURE,
  payload,
});

export const fetchCareRoomHistory = (payload, onSuccess) => ({
  type: FETCH_CARE_ROOM_HISTORY,
  payload,
  onSuccess,
});
export const fetchCareRoomHistorySuccess = (payload) => ({
  type: FETCH_CARE_ROOM_HISTORY_SUCCESS,
  payload,
});
export const fetchCareRoomHistoryFailure = (payload) => ({
  type: FETCH_CARE_ROOM_HISTORY_FAILURE,
  payload,
});

export const setRoomHistoryModal = (payload) => ({
  type: SET_ROOM_HISTORY_MODAL,
  payload,
});
//
export const editCareRoom = (payload) => ({
  type: EDIT_CARE_ROOM,
  payload,
});
export const editCareRoomSuccess = (payload) => ({
  type: EDIT_CARE_ROOM_SUCCESS,
  payload,
});
export const editCareRoomFailure = (payload) => ({
  type: EDIT_CARE_ROOM_FAILURE,
  payload,
});
//
export const setRoomAddEditModal = (payload) => ({
  type: SET_ROOM_ADD_EDIT_MODAL,
  payload,
});
//
export const openInviteModal = (payload) => ({
  type: OPEN_INVITE_MODAL,
  payload,
});
export const closeInviteModal = (payload) => ({
  type: CLOSE_INVITE_MODAL,
  payload,
});
//
export const inviteStaff = (payload, onInvSuccess) => ({
  type: INVITE_STAFF,
  payload,
  onInvSuccess,
});
export const inviteStaffSuccess = (payload) => ({
  type: INVITE_STAFF_SUCCESS,
  payload,
});
export const inviteStaffFailure = (payload) => ({
  type: INVITE_STAFF_FAILURE,
  payload,
});
//
export const profileStepEdit = (payload, onSuccess) => ({
  type: PROFILE_STEP_EDIT,
  payload,
  onSuccess,
});
export const profileStepEditSuccess = (payload) => ({
  type: PROFILE_STEP_EDIT_SUCCESS,
  payload,
});
export const profileStepEditFailure = (payload) => ({
  type: PROFILE_STEP_EDIT_FAILURE,
  payload,
});
//
export const toggleInviteRev = (payload) => ({
  type: TOGGLE_INVITE_REV,
  payload,
});
//
export const inviteReview = (payload, onSuccess) => ({
  type: INVITE_REVIEW,
  payload,
  onSuccess,
});
export const inviteReviewSuccess = (payload) => ({
  type: INVITE_REVIEW_SUCCESS,
  payload,
});
export const inviteReviewFailure = (payload) => ({
  type: INVITE_REVIEW_FAILURE,
  payload,
});
//
export const generateCard = (payload, onSuccess) => ({
  type: GENERATE_CARD,
  payload,
  onSuccess,
});
export const generateCardSuccess = (payload) => ({
  type: GENERATE_CARD_SUCCESS,
  payload,
});
export const generateCardFailure = (payload) => ({
  type: GENERATE_CARD_FAILURE,
  payload,
});
export const setCardList = (payload) => ({
  type: SET_CARD_LIST,
  payload,
});
export const setActiveLocation = (payload) => ({
  type: SET_ACTIVE_LOCATION,
  payload,
});
export const setActiveSurvey = (payload) => ({
  type: SET_ACTIVE_SURVEY,
  payload,
});
export const setUserLocations = (payload) => ({
  type: SET_USER_LOCATIONS,
  payload,
});
export const setActivePath = (payload) => ({
  type: SET_ACTIVE_PATH,
  payload,
});
//
export const fetchInvitees = (payload) => ({
  type: FETCH_INVITEES,
  payload,
});
export const fetchInviteesSuccess = (payload) => ({
  type: FETCH_INVITEES_SUCCESS,
  payload,
});
export const fetchInviteesFailure = (payload) => ({
  type: FETCH_INVITEES_FAILURE,
  payload,
});
//
export const exportReviews = (payload, onSuccess) => ({
  type: EXPORT_REVIEWS,
  payload,
  onSuccess,
});
export const exportReviewsSuccess = (payload) => ({
  type: EXPORT_REVIEWS_SUCCESS,
  payload,
});
export const exportReviewsFailure = (payload) => ({
  type: EXPORT_REVIEWS_FAILURE,
  payload,
});
export const setUserPath = (payload) => ({
  type: SET_USER_PATH,
  payload,
});

export const toggleTeamModal = (payload) => ({
  type: TOGGLE_TEAM_MODAL,
  payload,
});

//
export const deleteTeam = (payload, onSuccess) => ({
  type: DELETE_TEAM,
  payload,
  onSuccess,
});
export const deleteTeamSuccess = (payload) => ({
  type: DELETE_TEAM_SUCCESS,
  payload,
});
export const deleteTeamFailure = (payload) => ({
  type: DELETE_TEAM_FAILURE,
  payload,
});

//
export const toggleSortModal = (payload) => ({
  type: TOGGLE_SORT_MODAL,
  payload,
});

//
export const updateSeq = (payload, onSuccess) => ({
  type: UPDATE_SEQ,
  payload,
  onSuccess,
});
export const updateSeqSuccess = (payload) => ({
  type: UPDATE_SEQ_SUCCESS,
  payload,
});
export const updateSeqFailure = (payload) => ({
  type: UPDATE_SEQ_FAILURE,
  payload,
});

//
export const getFees = (payload) => ({
  type: GET_FEES,
  payload,
});
export const getFeesSuccess = (payload) => ({
  type: GET_FEES_SUCCESS,
  payload,
});
export const getFeesFailure = (payload) => ({
  type: GET_FEES_FAILURE,
  payload,
});

//
export const updateFee = (payload) => ({
  type: UPDATE_FEE,
  payload,
});
export const updateFeeSuccess = (payload) => ({
  type: UPDATE_FEE_SUCCESS,
  payload,
});
export const updateFeeFailure = (payload) => ({
  type: UPDATE_FEE_FAILURE,
  payload,
});

//
export const getProfile = (payload) => ({
  type: GET_PROFILE,
  payload,
});
export const getProfileSuccess = (payload) => ({
  type: GET_PROFILE_SUCCESS,
  payload,
});
export const getProfileFailure = (payload) => ({
  type: GET_PROFILE_FAILURE,
  payload,
});

//
export const deleteFile = (payload, onSuccess) => ({
  type: DELETE_FILE,
  payload,
  onSuccess,
});
export const deleteFileSuccess = (payload) => ({
  type: DELETE_FILE_SUCCESS,
  payload,
});
export const deleteFileFailure = (payload) => ({
  type: DELETE_FILE_FAILURE,
  payload,
});

//
export const deleteVideo = (payload, onSuccess) => ({
  type: DELETE_VIDEO,
  payload,
  onSuccess,
});
export const deleteVideoSuccess = (payload) => ({
  type: DELETE_VIDEO_SUCCESS,
  payload,
});
export const deleteVideoFailure = (payload) => ({
  type: DELETE_VIDEO_FAILURE,
  payload,
});

//
export const getBackView = (payload, onBackSuccess) => ({
  type: GET_BACK_VIEW,
  payload,
  onBackSuccess,
});
export const getBackViewSuccess = (payload) => ({
  type: GET_BACK_VIEW_SUCCESS,
  payload,
});
export const getBackViewFailure = (payload) => ({
  type: GET_BACK_VIEW_FAILURE,
  payload,
});

//
export const editBasic = (payload, onSuccess) => ({
  type: EDIT_BASIC,
  payload,
  onSuccess,
});
export const editBasicSuccess = (payload) => ({
  type: EDIT_BASIC_SUCCESS,
  payload,
});
export const editBasicFailure = (payload) => ({
  type: EDIT_BASIC_FAILURE,
  payload,
});
